var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('i',{staticClass:"fas fa-flag",style:('color: ' + _vm.params.value),attrs:{"aria-hidden":"true"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }